export default __webpack_public_path__ + "static/media/team-member-02.97b4417f.jpeg";